import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ContentWithCardLoading } from "../../../../components/loading";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import * as accountCampaignPricingSmsActions from "../../store/actions/account_campaign_pricing_sms_actions";
import AccountCampaignPricingSmsSidePanel from "./components/account-campaign-pricing-sms-side-panel";

const ACCOUNT_CAMPAIGN_PRICING_SMS_ACTIONS = {
  NONE: "NONE",
  EDIT: "EDIT",
};

export default function AccountCampaignPricingSms(props) {
  const [dataToShow, setDataToShow] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const [selectedPricingWithAction, setSelectedPricingWithAction] = useState({
    action: ACCOUNT_CAMPAIGN_PRICING_SMS_ACTIONS.NONE,
    data: {},
  });
  const accountCampaignPricingSmsList = useSelector((state) => state.accounts.accountCampaignPricingSms);
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(accountCampaignPricingSmsActions.getPricingOfAccountSmsCampaignRequest({ id: params.accountId }));
  }, [dispatch, params.accountId]);

  useEffect(() => {
    if (props.search) {
      const updatedData = accountCampaignPricingSmsList.data.filter(each => each.countryName.match(new RegExp(props.search, "gi")))
      const a = updatedData.slice((page - 1) * limit, (page - 1) * limit + limit);
      setDataToShow(a);
    }
    else {
      const updatedData = accountCampaignPricingSmsList.data;
      const a = updatedData.slice((page - 1) * limit, (page - 1) * limit + limit);
      setDataToShow(a)

    }
  }, [page, limit, props.search, accountCampaignPricingSmsList.data])

  return (
    <>
      {accountCampaignPricingSmsList.loading ? (
        <ContentWithCardLoading />
      ) : accountCampaignPricingSmsList.data.length === 0 ? (
        "No Data"
      ) : (
        // <CustomEmptyPage
        //   page="blockContact"
        //   setShowAdd={() => {
        //     setShow(true);
        //     setIsEdit(false);
        //   }}
        // />
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Country Name", apiKeyName: "countryName", fieldInputType: "INPUT" },
                { title: "Country", apiKeyName: "country", fieldInputType: "INPUT" },
                { title: "Route Name", apiKeyName: "routeName", fieldInputType: "INPUT" },
                { title: "Price", apiKeyName: "price", fieldInputType: "INPUT" },
                { title: "Additional Price", apiKeyName: "additionalPrice", fieldInputType: "INPUT" },
                { title: "Final Price", apiKeyName: "finalPrice", fieldInputType: "INPUT" },
                { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
                { title: "Gateway", apiKeyName: "gateway", fieldInputType: "INPUT" },
                { title: "Regulations", apiKeyName: "regulation", fieldInputType: "SELECT" },
                { title: "Action", isAction: true, options: ["edit"] },
              ]}
              data={dataToShow.map((each) => ({
                ...each,
                finalPrice: ((each.additionalPrice || 0) + (each.price || 0)).toFixed(4),
              }))}
              limit={limit}
              pageNo={page}
              setPageNo={setPage}
              setLimit={setLimit}
              count={accountCampaignPricingSmsList.data.length}
              // actions
              handleEdit={(data) => setSelectedPricingWithAction({ action: ACCOUNT_CAMPAIGN_PRICING_SMS_ACTIONS.EDIT, data })}
            />
          </div>
        </div>
      )}

      <AccountCampaignPricingSmsSidePanel
        show={selectedPricingWithAction.action === ACCOUNT_CAMPAIGN_PRICING_SMS_ACTIONS.EDIT}
        pricingData={selectedPricingWithAction.data}
        handleClose={() => setSelectedPricingWithAction({ action: ACCOUNT_CAMPAIGN_PRICING_SMS_ACTIONS.NONE, data: {} })}
      />
    </>
  );
}
